@if (preview) {
  <div
    class="flex flex-1 items-center justify-center rounded-md border-2 border-dashed p-2"
  >
    <span class="text-base text-slate-600">{{ "Diagnosi" | transloco }}</span>
  </div>
}

@if (!preview) {
  <div class="flex flex-1 flex-col">
    <div>
      <span class="text-sm text-slate-900">
        {{ "Diagnosi" | transloco }}
      </span>
    </div>
    <dx-tag-box
      [disabled]="readOnly"
      [value]="tags ?? []"
      [valueExpr]="'id'"
      [displayExpr]="'name'"
      [dataSource]="dxTagOrgans.dataSource"
      [searchEnabled]="true"
      [tagTemplate]="dxTagOrgans.tagTemplate"
      [acceptCustomValue]="true"
      [placeholder]="'Aggiungi un tag' | transloco"
      [customItemCreateEvent]="''"
      (onValueChanged)="onTagsUpdated($event.value)"
      (onCustomItemCreating)="dxTagOrgans.onCustomItemCreating($event)"
    ></dx-tag-box>
  </div>
}
